module.exports = __webpack_public_path__ + "img/0-02-0a-94a1274ddcd99825b986c7692aef3b88e8fc19d74987a38236e20080f616ab97_2a2bfa2a.25a8e2d6.jpg";